import { css } from '@emotion/css';
import {
  appColors,
  breakpoints,
  fontFamily,
} from '../../styles/variables.style';
import iconone from '../../assets/images/img-3928.jpeg';
import icontwo from '../../assets/images/img-3827.jpeg';
import selectArrow from '../../assets/images/select-arrow.png';

export const batchBanner = css`
  display: block;
  width: 100%;
  position: relative;
  padding: 0px 40px;
  @media (max-width: 767px) {
    padding: 0 20px;
    margin-bottom:0;
  }
  img {
    width: 100%;
    border-radius: 10px;
  }
  span {
    width: 100%;
    max-width: 330px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    @media (max-width: 767px) {
      text-align: center;
    }
    img {
      width: 100%;
      max-width: 330px;
      @media (max-width: 767px) {
        max-width: 150px;
      }
    }
  }
`;

export const batchTitle = css`
  text-align: center;
  padding: 10px 0;
  font-size: 36px;
  font-weight: 500;
  position: relative;
  font-family: Fredoka one, sans-serif;
  @media (max-width: 767px) {
    padding: 30px 0;
    font-size: 28px;
  }
  &:after {
    content: '';
    width: 65px;
    height: 4px;
    background: #edc224;
    position: absolute;
    left: 50%;
    top:55px;
    // bottom: 80px;
    transform: translate(-50%);
    @media (max-width: 767px) {
      // bottom: 18px;
    }
  }
`;

export const spellbowllicense = css`
  text-align: center;
  padding: 50px 0;
  font-size: 16px;
  font-weight: 500;
  position: relative;
  font-family: Fredoka one, sans-serif;
  @media (max-width: 767px) {
    padding: 30px 0;
    font-size: 28px;
  }
`;

export const practiceFluid = css`
  width: 100%;
  max-width: 1280px;
  margin: auto;
  padding: 0 15px;
  position: relative;
  &:before {
    @media (min-width: ${breakpoints.lg.up}) {
      content: '';
      width: 100%;
      background: url(${iconone}) no-repeat 18% -22px,
        url(${icontwo}) no-repeat 83% 65%;
      padding: 50px 20px;
      position: absolute;
      top: -120px;
      height: 160px;
      z-index: -1;
    }
  }
  .col-md-4 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 33.333333%;
    flex: 0 0 33.333333%;
    max-width: 33.333333%;
    padding: 10px 30px;
    @media (max-width: 992px) {
      padding: 10px 10px;
      @media (max-width: 767px) {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 100%;
        flex: 0 0 100%;
        max-width: 100%;
        padding: 0 20px;
        margin-bottom: 20px;
      }
    }
    &:nth-child(01) {
      .newCard-add {
        border-color: #edc224;
      }
      .card-body {
        h4 {
          color: #dd6e2b !important;
        }
      }
    }
    &:nth-child(03) {
      .card {
        border-color: #edc224;
        .card-body {
          h4 {
            color: #edc224;
          }
          .editevenbutton {
            background: #edc224;
          }
        }
      }
    }
    &:nth-child(04) {
      .card {
        border-color: #72ff6b;
        .card-body {
          h4 {
            color: #72ff6b;
          }
          .editevenbutton {
            background: #72ff6b;
          }
        }
      }
    }
    &:nth-child(05) {
      .card {
        border-color: #2b3cdd;
        .card-body {
          h4 {
            color: #2b3cdd;
          }
          .editevenbutton {
            background: #2b3cdd;
          }
        }
      }
    }
  }
  .card {
    width: 100%;
    box-shadow: none;
    border: 2px solid #de7028;
    border-radius: 8px;
    transition: all 0.5s;
    padding: 15px;
    height: auto;
    min-height: 420px;
    @media (max-width: 992px) {
      margin-bottom: 0;
    }
    &:hover {
      box-shadow: 0 0 20px rgba(0, 0, 0, 0.28) !important;
      transition: all 0.5s;
    }
    .overflow {
      img {
        width: 100%;
        border-radius: 8px;
        object-fit: cover;
        &:hover {
          transform: scale(1);
        }
      }
      .card-body {
        width: 100%;
        max-width: 100%;
        margin: auto;
        .custom-dropdown{
          min-width:inherit;
          width: 100%;
          padding: 0 20px;
          &:before{
            display:none;
          }
          &:after{
            display:none;
          }
          select{
            width: 100%;
            height: 40px;
            border: 1px solid ${appColors.gray800};
            border-radius: 5px;
            color: #636363;
            font-weight: normal;
            background: ${appColors.white};
            outline: none;
            -moz-appearance: none; /* Firefox */
            -webkit-appearance: none; /* Safari and Chrome */
            appearance: none;
            background-image: url(${selectArrow});
            background-repeat: no-repeat;
            background-size: 16px;
            background-position: 97%;
          }
        }
        h4 {
          padding: 0;
          margin: 10px 0;
          text-align: center;
          color: #dd6e2b;
          font-size: 18px;
          font-family: Fredoka one, sans-serif;
          font-weight: 400;
        }
        .editevenbutton {
          padding: 13px 0;
          background: #dd6e2b;
          border-radius: 8px;
          text-transform: uppercase;
          &:hover {
            background: #edc224;
            transition: all 0.5s;
          }
        }
      }
    }
  }
`;

export const allPracticeFluid = css`
  width: 100%;
  max-width: 1280px;
  margin: auto;
  padding: 0 15px;
  position: relative;
  &:before {
    @media (min-width: ${breakpoints.lg.up}) {
      content: '';
      width: 100%;
      background: url(${iconone}) no-repeat 18% -22px,
        url(${icontwo}) no-repeat 83% 65%;
      padding: 50px 20px;
      position: absolute;
      top: -120px;
      height: 160px;
      z-index: -1;
    }
  }
  .col-md-4 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 33.333333%;
    flex: 0 0 33.333333%;
    max-width: 33.333333%;
    padding: 10px 30px;
    @media (max-width: 992px) {
      padding: 10px 10px;
      @media (max-width: 767px) {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 100%;
        flex: 0 0 100%;
        max-width: 100%;
        padding: 0 20px;
        margin-bottom: 20px;
      }
    }
    &:nth-child(01) {
      .newCard-add {
        border-color: #edc224;
      }
      .card-body {
        h4 {
          color: #dd6e2b !important;
        }
      }
    }
    &:nth-child(03) {
      .card {
        border-color: #edc224;
        .card-body {
          h4 {
            color: #edc224;
          }
          .editevenbutton {
            background: #edc224;
          }
        }
      }
    }
    &:nth-child(04) {
      .card {
        border-color: #72ff6b;
        .card-body {
          h4 {
            color: #72ff6b;
          }
          .editevenbutton {
            background: #72ff6b;
          }
        }
      }
    }
    &:nth-child(05) {
      .card {
        border-color: #2b3cdd;
        .card-body {
          h4 {
            color: #2b3cdd;
          }
          .editevenbutton {
            background: #2b3cdd;
          }
        }
      }
    }
  }
  .card {
    width: 100%;
    box-shadow: none;
    border: 2px solid #de7028;
    border-radius: 8px;
    transition: all 0.5s;
    padding: 15px;
    height: auto;
    min-height: 420px;
    @media (max-width: 992px) {
      margin-bottom: 0;
    }
    &:hover {
      box-shadow: 0 0 20px rgba(0, 0, 0, 0.28) !important;
      transition: all 0.5s;
    }
    .overflow {
      img {
        width: 100%;
        border-radius: 8px;
        object-fit: cover;
        &:hover {
          transform: scale(1);
        }
      }
      .card-body {
        width: 100%;
        max-width: 100%;
        margin: auto;
        .custom-dropdown{
          min-width:inherit;
          width: 100%;
          padding: 0 20px;
          &:before{
            display:none;
          }
          &:after{
            display:none;
          }
          select{
            width: 100%;
            height: 40px;
            border: 1px solid ${appColors.gray800};
            border-radius: 5px;
            color: #636363;
            font-weight: normal;
            background: ${appColors.white};
            outline: none;
            -moz-appearance: none; /* Firefox */
            -webkit-appearance: none; /* Safari and Chrome */
            appearance: none;
            background-image: url(${selectArrow});
            background-repeat: no-repeat;
            background-size: 16px;
            background-position: 97%;
          }
        }
        h4 {
          padding: 0;
          margin: 10px 0;
          text-align: center;
          color: #dd6e2b;
          font-size: 18px;
          font-family: Fredoka one, sans-serif;
          font-weight: 400;
        }
        .editevenbutton {
          padding: 13px 0;
          background: #dd6e2b;
          border-radius: 8px;
          text-transform: uppercase;
          &:hover {
            background: #edc224 !important;
            transition: all 0.5s;
          }
        }
      }
    }
  }
`;

export const gradeSelectContainer = css`
  text-align: center;
  // margin-buttom: 1rem;
  label {
    display: block;
    font-size: 1.125rem;
    font-weight: 600;
    margin-bottom: 0.5rem;
  }
  select {
    width: 100%;
    max-width: 33%;
    padding: 0.5rem 1rem;
    border: 1px solid #db692f;
    border-radius: 0.375rem;
    box-shadow: 0 4px 6px rgba(219, 105, 47, 0.2);
    outline: none;
    transition: all 0.3s ease-in-out;
    background-color: #fff;
    cursor: pointer;
    color: #db692f;
    appearance: none;
    background-image: none;
  }

  select option {
    color: #000;
    cursor: pointer;
  }

  select option:hover {
    background-color: red;
    color: #fff;
  }
`;

export const subCategoryContainer = css`
  background-color: #f8f9fa;
  padding: 30px;
  border-radius: 15px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  margin: 20px auto; /* Centered with top/bottom margin */
  max-width: 700px; /* Limit width for better centering */
`;

export const subCategoryForm = css`
  .form-check {
    margin-bottom: 15px;
  }
  .form-check-label {
    font-size: 1.1rem;
    font-weight: 500;
    cursor: pointer;
    display: flex;
    align-items: center;
  }
  .form-check-input {
    margin-right: 10px;
    height: 20px;
    width: 20px;
    cursor: pointer;
  }
`;

export const startPracticeButton = css`
  background-color: #f16602;
  color: white;
  border: none;
  padding: 12px 30px;
  font-size: 1.2rem;
  font-weight: bold;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.3s ease, box-shadow 0.3s ease;
  width: 100%;

  &:hover {
    background-color: #db692f;
    box-shadow: 0 4px 15px rgba(241, 102, 2, 0.4);
  }

  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
    box-shadow: none;
  }
`;

export const subCategoryList = css`
  list-style: none;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  margin-bottom: 20px;
`;

export const subCategoryListItem = css`
  padding: 10px 20px;
  border: 2px solid #f16602;
  border-radius: 25px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.3s ease;
  background-color: #fff;
  color: #f16602;

  &:hover {
    background-color: #fef4e0;
  }
`;

export const subCategoryListItemSelected = css`
  background-color: #f16602;
  color: #fff;
  border-color: #f16602;

  &:hover {
    background-color: #db692f;
  }
`;

export const selectAllButton = css`
  background-color: #fff;
  border: 1px solid #f16602;
  color: #f16602;
  font-weight: 500;
  cursor: pointer;
  padding: 8px 16px;
  margin-bottom: 20px;
  border-radius: 8px;
  transition: all 0.3s ease;
  float: right;

  &:hover {
    background-color: #f16602;
    color: #fff;
  }
`;

export const practiceSettingsContainer = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  padding: 15px;
  background-color: #fef4e0;
  border-radius: 8px;
`;

export const infoText = css`
  font-size: 1rem;
  font-weight: bold;
  color: #343a40;
`;

export const timeSelector = css`
  select {
    border: 1px solid #f16602;
    border-radius: 5px;
    padding: 8px;
    font-weight: 500;
    color: #f16602;
    background-color: #fff;
    cursor: pointer;
  }
`;

export const settingsPanel = css`
  background: #f7f7f7;
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  padding: 20px;
  margin-top: 25px;
`;

export const settingsRow = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
`;

export const settingsLabel = css`
  font-size: 1.1rem;
  font-weight: bold;
  color: #d68b00;
`;

export const shuffleSwitch = css`
  position: relative;
  display: inline-block;
  width: 40px;
  height: 14px;
  input {
    opacity: 0;
    width: 0;
    height: 0;
  }
  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    transition: .4s;
    border-radius: 34px;
  }
  .slider:before {
    position: absolute;
    content: "";
    height: 13px;
    width: 13px;
    left: 1px;
    bottom: 1px;
    background-color: white;
    transition: .4s;
    border-radius: 50%;
  }
  input:checked + .slider {
    background-color: #f37521;
  }
  input:checked + .slider:before {
    transform: translateX(26px);
  }
`;

export const sliderContainer = css`
  display: flex;
  align-items: center;
  gap: 15px;
  margin-left: 20px;
`;

export const totalTimeDisplay = css`
  font-weight: 500;
  text-align: center;
  margin-top: 15px;
  font-size: 1.1rem;
  color: #343a40;
`;
